* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

gz-chips-generator-input {
  --chip-list-width: 524px;
}
